import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatBubbleDoubleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.4 16.1q.5-1.1-.3-2.3-1-1.5-1.1-3.4C4 7.1 7 4 11.2 4s7.2 3 7.2 6.4c0 3.3-3 6.4-7.2 6.4l-2.3-.3q-.7-.2-1.5 0l-2.6 1zm-3.8-5.7q0 2.8 1.6 4.8L1.7 19l-.1.5a1.3 1.3 0 0 0 1.8 1.2l4.9-2q1.4.5 2.9.5c5.3 0 9.6-4 9.6-8.8s-4.3-8.8-9.6-8.8-9.6 4-9.6 8.8m19.2 18.4q1.5 0 3-.4l4.8 2h.5a1.3 1.3 0 0 0 1.2-1.8l-1.5-3.8q1.5-2 1.6-4.8a9 9 0 0 0-7.2-8.5q-.2 1.2-.6 2.3c3.2.8 5.4 3.4 5.4 6.2q0 2-1.1 3.4-.7 1.2-.3 2.3l.6 1.5-2.6-1q-.7-.3-1.5-.1l-2.3.3c-3.6 0-6.3-2.3-7-5l-2.4.2c.8 4.1 4.7 7.2 9.4 7.2" })
});
export default SvgChatBubbleDoubleRegularIcon;
